import { createFileRoute, redirect } from "@tanstack/react-router";

// The prototype's role-based onboarding is replaced by passwordless signup (plan §11).
export const Route = createFileRoute("/_onboarding/onboarding/")({
  beforeLoad: () => {
    throw redirect({ to: "/join", replace: true });
  },
});
